import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import { useLenis } from "@/lib/useLenis";
import { ContentProvider } from "@/lib/useContent";

function AppShell() {
  useLenis();
  return (
    <div className="relative bg-[#080808] min-h-screen text-[#E0E0D8]">
      <div className="noise" aria-hidden />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#0d0d0d",
            border: "1px solid #2C2C2C",
            color: "#E0E0D8",
            borderRadius: 0,
            fontFamily: "JetBrains Mono, monospace",
            fontSize: 12,
            letterSpacing: "0.1em",
          },
        }}
      />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ContentProvider>
        <AppShell />
      </ContentProvider>
    </BrowserRouter>
  );
}
